import { ourProgramsHeroImage, ourProgramsHeroMobileImage } from "../images";

export const heroData = [
	{
		imageSource: [ourProgramsHeroImage, ourProgramsHeroMobileImage],
		heading: "Our Programs",
	},
];

export const programsData = [
	{
		title: "Basic Necessities Program",
		description:
			"We support vulnerable members of our community by operating a local food bank and providing basic necessities of life such as clothing, shelter, clean water, etc. Conditions apply to all beneficiaries of this program, beneficiaries must be able to demonstrate they meet the conditions requiring relief under this program. We are currently receiving donations for food and clothing items in cash or in kind. We welcome volunteers and donors to participate in this program.",
	},
	{
		title: "International Missions Program",
		description:
			"Our International Mission is a relief program to developing nations in cities where the citizens are in need of basic necessities of life. This program includes a ditigal literacy, financial training, entrepreneurhsip and leadership seminars to create sustainable growth for the members of the community. This is a yearly project, the location will be announced at the beginning of each year. This program spans across all the continents in the world. We welcome individuals and organizations to support this project as a volunteer or a donor.",
	},
	{
		title: "BIPOC Scholarship Fund",
		description:
			"This is a scholarship program for BIPOC (Black, Indigenous, and people of color) students attending a vocational/educational institution in Canada/United States. This scholarship fund is tailored for the BIPOC community and also open to other interested members of the public. Conditions apply to all beneficiaries of this program, beneficiaries must be able to demonstrate they meet the conditions required to receive this scholarship. We welcome partners interested in supporting us by donating to our scholarship fund, providing education materials, facilitating seminars and providing mentorship to students.",
	},
	{
		title: "GROW Relationship Series",
		description:
			"This is a structured educational program on marital life for intending partners, education for new parents, and relationship growth for married couples. Program participants are required to demonstrate their committment to attend at least 75% of the seminar series consisting of 4 sessions.",
	},
	{
		title: "Youth Empowerment Program",
		description:
			"We believe education is a continuous engagement. Our Youth Empowerment Porgram provides training/workshop to program participants in areas of entrepreneurship, community development, volunteerism, financial literacy and leadership. Conditions apply to all beneficiaries of this program, beneficiaries must be able to demonstrate they meet the conditions required for entrance into this program.",
	},
	{
		title: "Culture Advancement",
		description:
			"Cultural integration is an integral component of community development. Our program on cultural advancement is tailored to provide education on cultural innovation and promote cultural values. We are open to volunteers and donors to provide cultural works, teach various cultures, donate artworks, manage the cultural center, etc. ",
	},
	{
		title: "Digitial Literacy Education",
		description:
			"This is a structured training program to educate members of the public on digital literacy and information technology foundation skills for career development. Participants will learn how to use office productivity tools, installation of application, basic cybersecurity education, basic software development & programming.",
	},
	{
		title: "Character Education Seminar",
		description:
			"This is an education to support program participants to provide Holistic moral and civic development. Conditions apply to all beneficiaries of this program, beneficiaries must be able to demonstrate they meet the conditions required for entrance into this program.",
	},
	{
		title: "Relieve conditions associated with disability",
		description:
			"We provide empowerment training and equipment support to individuals with conditions associated with disability. Conditions apply to all beneficiaries of this program, beneficiaries must be able to demonstrate they meet the conditions required for entrance into this program.",
	},
];
